import React from 'react'

import RequestFormField from "../../../../../../core/model2/form/settings/field"
import FieldFormElement from "../../../../../../core/fields3/render/form-elemnent"
import FormManager from "../../../../../../core/gd-form/common/form-manager"
import FormError from "../../../../../../core/gd-form/common/form-error/form-error"
import {FieldType} from "../../../../../../core/fields3/field-type"
import RequestForm from "../../../../../../core/model2/form/request-form"

type Props = {
    requestForm : RequestForm
    formField   : RequestFormField
    form        : FormManager
}

// const debug = "FormRowField"
const debug = false

export default function FormRowField(props:Props) {
    debug && console.log(debug, 'render', props.formField.field, props)

    const formElementClasses = Classes({
        'w-300': props.formField.field && ![
            FieldType.STRING,
            FieldType.NUMBER,
            FieldType.TEXT,
            FieldType.EMAIL
        ].includes(props.formField.field.type)
    })

    // all form text shoudl be 4 lines height
    let rows : undefined | number = undefined
    if (props.formField.field?.type === FieldType.TEXT) {
        rows = 4
    }

    return (
        <div className="form-row">
            <div className="form-row-content">
                <div className="title">
                    {props.formField.label}
                    {props.formField.isRequired &&
                        <span className="required">*</span>}
                </div>
                {props.formField.description &&
                    <div className="desc">{props.formField.description}</div>}

                <div className="element">
                    {props.formField.field &&
                        <>
                            <FieldFormElement
                                className   = {formElementClasses}
                                field       = {props.formField.field}
                                form        = {props.form}
                                model       = {props.requestForm}
                                rows        = {rows}
                                disabled    = {false}
                            />
                            <FormError
                                className   = {formElementClasses}
                                form        = {props.form}
                                name        = {props.formField.field.fieldId}
                            />
                        </>}
                </div>
            </div>
        </div>
    )
}
